// Shared inline-SVG placeholder for listing imagery.
//
// A single self-contained data-URI so a parcel with no photo (or a
// listing photo/preview/satellite tile that 404s) renders a clean
// "No image" card instead of the browser's broken-image glyph, with
// zero extra network round-trips. Extracted from PropertyCard.js so
// PropertyCard and ParcelDetail share one literal instead of drifting
// (#1018).
//
// eslint-disable-next-line max-len
export const PLACEHOLDER_IMG =
  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="320" height="180" viewBox="0 0 320 180"><rect width="320" height="180" fill="%23eef2f7"/><g fill="%23a0aab8" font-family="system-ui,Arial,sans-serif"><text x="50%25" y="50%25" text-anchor="middle" dominant-baseline="central" font-size="18" font-weight="600">No image</text><text x="50%25" y="68%25" text-anchor="middle" font-size="11" opacity="0.7">listing media not synced</text></g></svg>';

export default PLACEHOLDER_IMG;
